module.exports = __webpack_public_path__ + "011.43748d06.png";